import {
  aCreateThresholdRule,
  aThresholdRule,
  CreateThresholdRuleBuilderOperationMutation,
  mockCreateThresholdRuleBuilderOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { THRESHOLD_RULE_DATA } from '../queries/RuleBuilderQueryOperation.mocks';

export const createThresholdRuleResponse: CreateThresholdRuleBuilderOperationMutation =
  {
    __typename: 'Mutation',
    // @ts-ignore windowSizeInMillisecnds is aliased which causes issues with typing since MSW doesn't handle this case
    createThresholdRule: aCreateThresholdRule({
      data: {
        ...aThresholdRule({ id: THRESHOLD_RULE_DATA.ruleId }),
        // @ts-ignore windowSizeInMillisecnds is aliased which causes issues with typing since MSW doesn't handle this case
        windowSizeMilliseconds: THRESHOLD_RULE_DATA.windowSizeInMilliseconds,
      },
    }),
  };

export const handlers = [
  mockCreateThresholdRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        // @ts-ignore windowSizeInMillisecnds is aliased which causes issues with typing since MSW doesn't handle this case
        data: createThresholdRuleResponse,
      });
    }
  ),
];
